function Maps() {
}

Maps.fn = {
    init: function() {
        if($('.use-maps').length) {
            Maps.fn.initMap.call(this);
            Maps.fn.placeAutoComplete.call(this);
        }
    },
    initMap: function() {
        var root = this;
        var map;
        var marker = false;

        root.map = map;
        root.marker = marker;

        $(document).on('click', '.maps-marker', function(e){
            if ($(this).hasClass('event-default')) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            
            var _this = $(this);
            var maps = _this.closest('.maps');
            var latInput = maps.find('.latitude');
            var longInput = maps.find('.longitude');
            var mapModal = _this.closest('.maps').find('.signin-frm').attr('id'); //'modal-box-map';
            var mapView = mapModal + '-view';
            var lat = 50.162522;
            var long = 3.1806286;

            if(latInput.length && longInput.length && latInput.val() != '' && longInput.val() != '') {
                lat = latInput.val();
                long = longInput.val();
            }

            var latlng = new google.maps.LatLng(lat, long);
            var options = { zoom: 15, center: latlng };
            root.marker = new google.maps.Marker({ position: latlng });

            root.map = new google.maps.Map(document.getElementById(mapView), options);
            root.marker.setMap(root.map);

            //Listen for any clicks on the map.
            google.maps.event.addListener(root.map, 'click', function(event) {
                //Get the location that the user clicked.
                var clickedLocation = event.latLng;
                //If the marker hasn't been added.
                if(root.marker === false){
                    //Create the marker.
                    root.marker = new google.maps.Marker({
                        position: clickedLocation,
                        map: root.map,
                        draggable: true //make it draggable
                    });
                    //Listen for drag events!
                    google.maps.event.addListener(root.marker, 'dragend', function(event){
                        markerLocation();
                    });
                } else{
                    //Marker has already been added, so just change its location.
                    root.marker.setPosition(clickedLocation);
                }
                //Get the marker's location.
                markerLocation();
            });

            //This function will get the marker's current location and then add the lat/long
            //values to our textfields so that we can save the location.
            function markerLocation(){
                //Get location.
                var currentLocation = root.marker.getPosition();
                //Add lat and lng values to a field that we can save.
                latInput.val(currentLocation.lat()).trigger('change'); //latitude
                longInput.val(currentLocation.lng()).trigger('change'); //longitude
            }

            $('#'+ mapModal).modal('show');
        });
    },
    placeAutoComplete: function() {
        var bindSearch = function(element) {
            var _this = $(element);
            var preventSubmit = _this.hasClass('prevent-submit');
            var form = $(element).closest('form');
            var maps = _this.closest('.maps');
            var latInput = maps.find('.latitude');
            var longInput = maps.find('.longitude');
            var options = {};
            var autocomplete = new google.maps.places.Autocomplete(element, options);

            if(_this.val() == '') {
                latInput.val('');
                longInput.val('');
            }

            google.maps.event.addListener(autocomplete, 'place_changed', function() {
                var place = autocomplete.getPlace();
                var lat = place.geometry.location.lat();
                var lng = place.geometry.location.lng();

                if(latInput.length && longInput.length) {
                    latInput.val(lat).trigger('change');
                    longInput.val(lng).trigger('change');

                    // Only enable submit button when not prevent submit
                    if (!preventSubmit) {
                        form.find('button[type=submit]').prop('disabled', false);
                    }
                }
            });
        };

        $('.maps .location').map(function(){
            bindSearch(this);
        });

        $(document).on('focus keyup keypress blur change', '.maps .location', function() {
            bindSearch(this);
        });
    },
    rule: function() {
        $(document).ready(function() {
            Maps.fn.init.call(this);
        });
    }
};

Maps.fn.rule();